var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7102 2.45766C10.4658 2.66058 10.2284 2.8859 10 3.13439C9.7716 2.8859 9.53421 2.66058 9.27502 2.44544C2.884 -2.83033 -8.2924 7.16639 10 19C28.2924 7.16639 17.116 -2.83033 10.7102 2.45766ZM10.7362 3.81112C13.2316 1.09637 17.1826 1.5653 18.5536 4.36718C20.1914 7.71436 17.6058 12.7324 10 17.8037C2.39421 12.7324 -0.191354 7.71436 1.44642 4.36718C2.81738 1.5653 6.76844 1.09637 9.26377 3.81112L10 4.61208L10.7362 3.81112Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5778 4.36453C17.2069 1.56265 13.2558 1.09373 10.7605 3.80847L10.0243 4.60944L9.28803 3.80847C6.7927 1.09373 2.84164 1.56265 1.47068 4.36453C-0.167095 7.71172 2.41847 12.7298 10.0243 17.801C17.63 12.7298 20.2156 7.71172 18.5778 4.36453Z",
    fill: "#F50000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHeart);
export default __webpack_public_path__ + "static/media/filledHeart.537c33f5fb45465cba247aec1c399134.svg";
export { ForwardRef as ReactComponent };